import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat.js";

/**
 * Format date to string
 * @param value {String|Object}
 * @param format {String}
 * @return {String}
 */
function formatDate(value, format) {
  if (!value) {
    return "";
  }
  dayjs.extend(advancedFormat);
  return dayjs(value).format(format);
}

function formatMessageTime(value) {
  return formatDate(value, dayjs(value).isToday() ? "HH:mm" : "ddd D MMM HH:mm");
}

export { formatDate, formatMessageTime };
